
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_SUCCESS = 'CREATE_ORGANIZATION_SUCCESS';
export const GET_EXPERT = 'GET_EXPERT';
export const EXPERT_DATA_CLEAR = 'EXPERT_DATA_CLEAR';
